function escapeHTML(str) {
  if (typeof str !== 'string') return str;

  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  };

  return str.replace(/[&<>"']/g, (m) => map[m]);
}

export default escapeHTML;
